module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.c139ffb2.eot";